import { PcsInformationConstants } from '../store/pcsInformation.constants'

export const pcsInformationSchemas = [
  {
    inputKey: PcsInformationConstants.SET_LASTNAME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_LASTNAME: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,100}$',
      },
    },
    additionalProperties: false,
    required: ['SET_LASTNAME'],
    errorMessage: {
      properties: {
        SET_LASTNAME: 'Must be alphanumeric with max length of 100',
      },
    },
  },
  {
    inputKey: PcsInformationConstants.SET_FIRSTNAME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_FIRSTNAME: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,100}$',
      },
    },
    additionalProperties: false,
    required: ['SET_FIRSTNAME'],
    errorMessage: {
      properties: {
        SET_FIRSTNAME: 'Must be alphanumeric with max length of 100',
      },
    },
  },
  {
    inputKey: PcsInformationConstants.SET_MILESTOHOSP,
    isNumber: true,
    type: 'object',
    properties: {
      SET_MILESTOHOSP: {
        minimum: 0,
        maximum: 1000.0,
      },
    },
    additionalProperties: false,
    required: ['SET_MILESTOHOSP'],
    errorMessage: {
      properties: {
        SET_MILESTOHOSP: 'Mileage to closest hospital must be between 0 to 1000 or blank',
      },
    },
  },
  {
    inputKey: PcsInformationConstants.SET_PCSSIGNEDTIME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_PCSSIGNEDTIME: {
        type: 'string',
        pattern: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9](?::[0-5][0-9])?$',
      },
    },
    additionalProperties: false,
    required: ['SET_PCSSIGNEDTIME'],
    errorMessage: {
      properties: {
        SET_PCSSIGNEDTIME: 'Must be in the format: HH:MM and between 00:00 and 23:59',
      },
    },
  },
  {
    inputKey: PcsInformationConstants.SET_PCSSIGNEDDATE,
    isNumber: false,
    type: 'object',
    properties: {
      SET_PCSSIGNEDDATE: {
        type: 'string',
        format: 'zoll-now-date',
      },
    },
    additionalProperties: false,
    required: ['SET_PCSSIGNEDDATE'],
    errorMessage: {
      properties: {
        SET_PCSSIGNEDDATE: 'Must be in the format: MM/DD/YY and between 01/01/1950 and 01/01/2050',
      },
    },
  },
]

export const pcsInformationSecondsSchemas = [
  {
    inputKey: PcsInformationConstants.SET_PCSSIGNEDTIME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_PCSSIGNEDTIME: {
        type: 'string',
        pattern: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$',
      },
    },
    additionalProperties: false,
    required: ['SET_PCSSIGNEDTIME'],
    errorMessage: {
      properties: {
        SET_PCSSIGNEDTIME: 'Must be in the format: HH:MM:SS and between 00:00:00 and 23:59:59',
      },
    },
  },
]
